
document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined' && window.innerWidth < 768) {
        new Swiper('.reviews-swiper', {
            slidesPerView: 1
            , spaceBetween: 16
            , navigation: {
                nextEl: '.reviews-next'
                , prevEl: '.reviews-prev'
                ,
            }
            ,
        });

        new Swiper('.benefits-swiper', {
            slidesPerView: 'auto'
            , spaceBetween: 16
            , navigation: {
                nextEl: '.benefits-next'
                , prevEl: '.benefits-prev'
                ,
            }
            ,
        });

        new Swiper('.similar-products-swiper', {
            slidesPerView: 'auto'
            , spaceBetween: 16
            , navigation: {
                nextEl: '.similar-products-next'
                , prevEl: '.similar-products-prev'
                ,
            }
            ,
        });

        new Swiper('.references-swiper', {
            slidesPerView: 'auto'
            , spaceBetween: 16
            , navigation: {
                nextEl: '.references-next'
                , prevEl: '.references-prev'
                ,
            }
            ,
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const showMoreBtn = document.getElementById('show-more-product-description');
    const descriptionPreview = document.querySelector('.description-preview');

    if (showMoreBtn && descriptionPreview) {
        const originalDisplay = descriptionPreview.style.display;
        const originalWebkitLineClamp = descriptionPreview.style.webkitLineClamp;
        const originalWebkitBoxOrient = descriptionPreview.style.webkitBoxOrient;

        descriptionPreview.style.display = 'block';
        descriptionPreview.style.webkitLineClamp = 'unset';
        descriptionPreview.style.webkitBoxOrient = 'unset';

        const fullHeight = descriptionPreview.scrollHeight;

        descriptionPreview.style.display = originalDisplay;
        descriptionPreview.style.webkitLineClamp = originalWebkitLineClamp;
        descriptionPreview.style.webkitBoxOrient = originalWebkitBoxOrient;

        const computedStyle = window.getComputedStyle(descriptionPreview);
        const lineHeight = parseFloat(computedStyle.lineHeight) || parseFloat(computedStyle.fontSize) * 1.2;
        const maxHeight = lineHeight * 3;

        if (fullHeight <= maxHeight) {
            showMoreBtn.style.display = 'none';
            console.log('Content fits in 3 lines, hiding button');
        } else {
            console.log('Content is longer than 3 lines, showing button');
            showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();

                if (descriptionPreview.classList.contains('expanded')) {
                    descriptionPreview.classList.remove('expanded');
                    showMoreBtn.textContent = 'Mehr anzeigen';
                    showMoreBtn.classList.remove('expanded');
                } else {
                    descriptionPreview.classList.add('expanded');
                    showMoreBtn.textContent = 'Weniger anzeigen';
                    showMoreBtn.classList.add('expanded');
                }
            });
        }
    } else {
        console.log('Elements not found:', {
            showMoreBtn: !!showMoreBtn
            , descriptionPreview: !!descriptionPreview
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const toggleBtn = document.getElementById('toggle-product-description');
    const routeToggleBtn = document.getElementById('route-show-more-product-description');
    const desc = document.getElementById('clamped-description');

    if (toggleBtn && desc) {
        toggleBtn.addEventListener('click', function (e) {
            e.preventDefault();
            desc.classList.toggle('expanded');
            toggleBtn.textContent = desc.classList.contains('expanded') ?
                'Weniger anzeigen' :
                'Mehr anzeigen';
        });
    }

    if(routeToggleBtn && desc) {
        routeToggleBtn.addEventListener("click", function (e) {
            e.preventDefault();
            scrollToSection('clamped-description');

            desc.classList.add('expanded');
            toggleBtn.textContent = desc.classList.contains('expanded') ?
                'Weniger anzeigen' :
                'Mehr anzeigen';
        })
    }
});

function scrollToSection(id, offset = 256) {
    const el = document.getElementById(id);
    if (!el) return;

    const y = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
}
